import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const StatsContainerStyled = styled(Box).attrs({
  py: { sm: '400' },
  px: { sm: '450' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
  `};
`;
